import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";
import { Store } from "@ngrx/store";
import {
    fetchDownlines,
    getDownline,
    addInvitation
} from "../../store/downline/downline.actions";
import { getDownlinesSelector, getDownlineSelector } from '@store/downline/downline.selectors';
import { IState } from '@models/index';
import { HelperService } from '../helper/helper.service';

@Injectable({
  providedIn: "root"
})
export class DownlineService {
  backendUrl = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private store: Store<{ downline: IState }>
  ) {}

  getDownlinesSelector(): Observable<IState> {
    return this.store.select(getDownlinesSelector);
  }

  getDownlineSelector(): Observable<IState> {
    return this.store.select(getDownlineSelector);
  }

  fetchDownlines(page: number, filterOptions: any): void {
    this.store.dispatch(fetchDownlines({ page, filterOptions }));
  }

  fetchDownline(downlineID: string): void {
    this.store.dispatch(getDownline({ downlineID }))
  }

  sendInvitation(invitation) {
    this.store.dispatch(addInvitation({ invitation }));
  }

  getDownlines(page: number, filterOptions: any = { }) {
    const queryparams = { ...{ page }, ...filterOptions };
    const queryString = HelperService.generateQueryParams(queryparams);
    return this.http.get(`${this.backendUrl}/users/user/downlines?${queryString}`);
  }

  getDownline(downlineID: string) {
    return this.http.get(`${this.backendUrl}/payments/payment/${downlineID}`);
  }

  insertInvitation(invitation) {
    return this.http.post(`${this.backendUrl}/users/user/invite`, invitation);
  }
}
